import { render, staticRenderFns } from "./DayCell.vue?vue&type=template&id=32748586&scoped=true&"
import script from "./DayCell.vue?vue&type=script&lang=js&"
export * from "./DayCell.vue?vue&type=script&lang=js&"
import style0 from "./DayCell.vue?vue&type=style&index=0&id=32748586&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32748586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!C:/Repository/SPRAYER_MANAGER/SPRAYER_MANAGER_SITO/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Resize } from 'vuetify/lib/directives'
import { Ripple } from 'vuetify/lib/directives'
installDirectives(component, {Resize,Ripple})
